import React, { useContext, useEffect } from "react";
import { FeedbackHero } from "./FeedbackHero";
import { SingleFeedback } from "./SingleFeedback";
import { Button } from "../Button";
import { useTranslation } from "react-i18next";
import { QRFeedbackContextProps } from "@/contexts/QRFeedbackContext/types";
import { QRFeedbackContext } from "@/contexts/QRFeedbackContext";

export const FeedbackFormPreview = ({ data, isInitPreview, isEditor }) => {
  const { categories, themeColor } = data || {};
  const { t } = useTranslation("feedback");

  const qrFeedbackContextData =
    useContext<QRFeedbackContextProps>(QRFeedbackContext);
  const { selectedReviewCategory, setSelectedReviewCategoryIndex } =
    qrFeedbackContextData;

  useEffect(() => {
    if (data) {
      setSelectedReviewCategoryIndex(0);
    }
  }, [data]);

  return (
    <>
      <FeedbackHero data={data} isInitPreview={isInitPreview} />
      <div className={`feedback-content`}>
        <SingleFeedback
          data={data}
          isInitPreview={isInitPreview}
          category={selectedReviewCategory}
        />
      </div>
      <div className="feedback-buttons feedback-button">
        <Button
          label={t("_sendFeedbackButtonLabel")}
          dataQA="feedback-submit-button"
          small
          buttonColor={themeColor.buttonColor}
          disabled={categories?.length > 1}
        />
      </div>
    </>
  );
};
